<template>
    <div class="ath-sticky-header"
        :style="uiStyle">
        <slot name="content"></slot>
    </div>
</template>

<script>
export default {
    name: 'mead-sticky-header',
    props: {
        /**
         * Id of the scrollable element to find on mount and listen to for scroll events. Falls
         * back to the closest `[ath-sticky-header-target]` ancestor if not found.
         */
        scrollElId: {type: [String], default: () => ''},
        /**
         * Where the top of this header should stick to, in rem (essentially the nav bar height).
         */
        top         : {type: [Number], default: () => 12},
        /**
         * CSS z-index applied to the header while it is fixed/stuck, so it can
         * be layered correctly relative to other fixed elements.
         */
        uiZIndex    : {type: [Number], default: () => 100},
        /**
         * When true, disables the sticky/fixed behavior entirely, letting the
         * header scroll normally with its surrounding content.
         */
        disabled    : {type: [Boolean], default: () => false},
    },
    data: function () {
        return {
            is_fixed    : false, // If header is currently fixed
            top_on_fixed: false, // Location the header was fixed at (for resetting)
            width       : 0,     // Width of header before being fixed, to maintain size
            scroll_el   : false, // Scroll element to listen to
        };
    },
    methods: {
        //  Called anytime our scollEl scrolls
        onScroll: function () {
            //  Scrolled back up past where the header fixed, unlock it
            if (this.is_fixed && this.scroll_el.scrollTop < this.top_on_fixed) {
                this.is_fixed = false;
            } else if (!this.is_fixed && this.$el.getBoundingClientRect().top <= this.top * 10) {
                //  Scrolled past header, lock it to the top of the page and note the top position
                this.width = this.$el.getBoundingClientRect().width;
                this.top_on_fixed = this.scroll_el.scrollTop;
                this.is_fixed = true;
            }
        },
        bindScrollListener: function () {
            if (!this.scroll_el) return;
            this.scroll_el.addEventListener('scroll', this.onScroll);
        },
    },
    computed: {
        uiStyle: function () {
            if (!this.is_fixed || this.disabled) return {};
            return {
                position : 'fixed',
                width    : `${this.width}px`,
                top      : `${this.top}rem`,
                'z-index': this.uiZIndex,
            };
        },
    },
    mounted () {
        let scroll_root = document.getElementById(this.scrollElId);
        this.scroll_el = scroll_root ? scroll_root : false;

        //  Fallback to sticky-header-target attribute if id not provided or working
        if (!this.scroll_el) {
            scroll_root = this.$el.closest('[ath-sticky-header-target]');
            this.scroll_el = scroll_root ? scroll_root : false;
        }

        this.bindScrollListener();
    },
    destroyed () {
        if (!this.scroll_el) return;
        this.scroll_el.removeEventListener('scroll', this.onScroll);
    },
};
</script>
